module.exports = __webpack_public_path__ + "static/media/code.5e7312e0.svg";